import { Component, OnInit } from '@angular/core';
import { ProjectFormComponent } from 'src/app/projects/project-form/project-form.component';
import { WindowService } from 'src/app/shared/components/window/window.service';
import { Project } from '../state/project.model';
import { ProjectQuery } from '../state/project.query';

@Component({
  selector: 'app-project-list-menu',
  templateUrl: './project-list-menu.component.html',
  styleUrls: ['./project-list-menu.component.scss']
})
export class ProjectListMenuComponent implements OnInit {

  project: Project;

  constructor(
    private windowService: WindowService,
    private projectQuery: ProjectQuery
  ) { }

  ngOnInit(): void {
    this.projectMenu();
  }

  private projectMenu() {
    this.projectQuery.selectActive().subscribe(project => {
      this.project = project;
    });
  }

  newProject() {
    const titleConfig = $localize`NEW DESIGN`;
    this.windowService.open({
      title: titleConfig,
      componentType: ProjectFormComponent,
      help: 'ADD_PROJECT',
      config: { id: 'NEW_PROJECT' }
    });
  }
}
